import { environment } from '@environments/environment';
const ɵ0 = environment.eddressAppConfig.apiBaseUrl, ɵ1 = environment.eddressAppConfig.graphqlBaseUrl, ɵ2 = environment.eddressAppConfig.mainPortalUrl;
export class AppModule {
}
export { ɵ0, ɵ1, ɵ2 };
